<template>
  <div>
    <form class="md-layout" @submit.prevent="onSubmit">
      <md-card class="md-layout-item md-size-60 md-small-size-100 md-elevation-10 form-card" style="">
        <md-card-header>
          <div class="md-title">Mensaje:</div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('firstName')">
                <label for="first-name">Nombre </label>
                <md-input name="first-name" id="first-name" autocomplete="given-name" v-model="form.name" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.name.required">El nombre es necesario</span>
                <span class="md-error" v-else-if="!$v.form.name.minlength">El nombre es demasiado corto</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100">
              <md-field :class="getValidationClass('firstName')">
                <label for="last-name">Apellido </label>
                <md-input name="last-name" id="last-name" autocomplete="given-name" v-model="form.last_name" :disabled="sending" />
                <span class="md-error" v-if="!$v.form.last_name.required">El nombre es necesario</span>
                <span class="md-error" v-else-if="!$v.form.last_name.minlength">El nombre es demasiado corto</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-small-size-100" >
              <md-field id="md-label-id">
                  <label for="movies">Motivo</label>
                  <md-select v-model="form.subject" name="movies" id="movies">
                    <md-option value="Huella de Carbono">Huella de Carbono</md-option>
                    <md-option value="Carbono Neutral">Carbono Neutral</md-option>
                    <md-option value="HuellaChile">HuellaChile</md-option>
                    <md-option value="Huella del Agua">Huella del Agua</md-option>
                    <md-option value="Huella de evento">Huella de evento</md-option>
                    <md-option value="Bonos de carbono">Bonos de carbono</md-option>
                    <md-option value="Certificado azul">Certificado azul</md-option>
                    <md-option value="Energía renovable">Energía renovable</md-option>
                    <md-option value="Otro">Otro</md-option>
                  </md-select>
                </md-field>
            </div>
          </div>

          <md-field :class="getValidationClass('email')">
            <label for="email">Email</label>
            <md-input type="email" name="email" id="email" autocomplete="email" v-model="form.email" :disabled="sending" />
            <span class="md-error" v-if="!$v.form.email.required">Tu email es requerido</span>
            <span class="md-error" v-else-if="!$v.form.email.email">tipo de email no reconocido</span>
          </md-field>

          <md-field>
            <label>Mensaje</label>
            <md-textarea v-model="form.message"></md-textarea>
          </md-field>
        </md-card-content>

        <md-progress-bar md-mode="indeterminate" v-if="sending" />
        <div id="g-recaptcha" class="g-recaptcha"  ref="recaptcha"></div>
        <md-button type="submit" class="md-raised md-success" :disabled="sending">Enviar</md-button>
      </md-card>

      <md-snackbar :md-active.sync="userSaved">The user {{ lastUser }} was saved with success!</md-snackbar>
    </form>
  <div>
    
  </div>
  </div>
</template>

<script>
  import Swal from 'sweetalert2'
  import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'

  export default {
    name: 'FormValidation',
    components: {  },
    mixins: [validationMixin],
    data: () => ({
      form: {
        name: null,
        subject: [],
        email: null,
        message: ''
      },

      sitekey: '6Lc2zeEZAAAAAPrl7QVJnGGJdkDN477PiCStAepN',
      widgetId: 0,
      userSaved: false,
      sending: false,
      lastUser: null,
      textarea: ''
    }),
     
    validations: {
      form: {
        name: {
          required,
          minLength: minLength(3)
        },
        last_name: {
          required,
          minLength: minLength(3)
        },
        age: {
          required,
          maxLength: maxLength(3)
        },
        gender: {
          required
        },
        email: {
          required,
          email
        }
      }
    },

    mounted () {
      this.render();
    },

    methods: {
       execute () {
         grecaptcha.execute(this.widgetId)
       },
       reset () {
         grecaptcha.reset(this.widgetId)
       },
       render () {
         if (grecaptcha) {
           this.widgetId = grecaptcha.render('g-recaptcha', {
             sitekey: this.sitekey,
             size: 'invisible',
             // the callback executed when the user solve the recaptcha
             callback: (response) => {
               // emit an event called verify with the response as payload
               this.$emit('verify', response)
               // reset the recaptcha widget so you can execute it again
               this.reset() 
             }
           })
         }
       },

      getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
      clearForm () {
        this.$v.$reset()
        this.form.name = null
        this.form.last_name = null
        this.form.subject = []
        this.form.email = null
        this.form.message = ''
      },
      saveUser () {
        this.sending = true

        // Instead of this timeout, here you can call your API
        window.setTimeout(() => {
          this.lastUser = `${this.form.name}`
          this.userSaved = true
          this.sending = false
          this.clearForm()
        }, 1500)
      },
      onCaptchaExpired: function () {
        this.$refs.recaptcha.reset();
      } ,
      async onSubmit () {
        if (this.form.name == null) 
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Nombre es requerido. Debe contener al menos 3 caracteres.',
            'error'
          )
          this.sending = false
          return
        }
          
        if (this.form.name.length < 3)
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Nombre es requerido. Debe contener al menos 3 caracteres.',
            'error'
          )
          this.sending = false
          return
        }

        if (this.form.last_name == null) 
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Apellido es requerido. Debe contener al menos 3 caracteres.',
            'error'
          )
          this.sending = false
          return
        }

        if (this.form.last_name.length < 3)
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Apellido es requerido. Debe contener al menos 3 caracteres.',
            'error'
          )
          this.sending = false
          return
        }

        if (this.form.subject == null)
        {
          Swal.fire(
            'Tuvimos un problema',
            'Se debe especificar un Motivo.',
            'error'
          )
          this.sending = false
          return
        }

        if (this.form.subject.length === 0)
        {
          Swal.fire(
            'Tuvimos un problema',
            'Se debe especificar un Motivo.',
            'error'
          )
          this.sending = false
          return
        }

        if (this.form.email == null) 
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Email es requerido.',
            'error'
          )
          this.sending = false
          return
        }

        let regex = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}');
        if (!regex.test(this.form.email))
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Email es requerido.',
            'error'
          )
          this.sending = false
          return
        }

        if (this.form.message == null)
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Mensaje es requerido y debe contener un minimo de 10 caracteres.',
            'error'
          )
          this.sending = false
          return
        }
 
        if (this.form.message.length < 10)
        {
          Swal.fire(
            'Tuvimos un problema',
            'El Mensaje es requerido y debe contener un minimo de 10 caracteres.',
            'error'
          )
          this.sending = false
          return
        }

        this.sending = true
        await axios.post('/email', {
          name: this.form.name,
          last_name: this.form.last_name,
          email: this.form.email,
          subject: this.form.subject,
          message: this.form.message
        })
        .then(function (response) {
           Swal.fire(
          'Gracias por contactarnos',
          '¡Pronto recibiras noticias de nosotros!',
          'success'
          )
        })
        .then( () => {
          this.form.name = null
          this.form.last_name = null
          this.form.email= null
          this.form.subject = []
          this.form.message = null
          this.sending = false
        })
        .catch( (error) => {
          console.log(error);
          Swal.fire(
            'Tuvimos un problema',
            'Por favor intenta nuevamente',
            'error'
          )
          this.sending = false
        });
      }
    }
  }
</script>
